import { useTenantContext } from '../tenant-context/index.tsx';

export const useIsAnonymous = (): boolean => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.isAnonymous;
};
